import React from 'react';

interface CheckboxInputProps {
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

const CheckboxInput: React.FC<CheckboxInputProps> = ({ label, checked, disabled, onChange }) => (
  <div className="form-check mb-3">
    <input
      type="checkbox"
      className="form-check-input"
      checked={checked}
      id={label}
      disabled={disabled}
      onChange={e => onChange(e.target.checked)}
    />
    <label className="form-check-label" htmlFor={label}>{label}</label>
  </div>
);

export default CheckboxInput;
